import { render, staticRenderFns } from "./tenantCompany.vue?vue&type=template&id=f8fd929c&scoped=true"
import script from "./tenantCompany.vue?vue&type=script&lang=js"
export * from "./tenantCompany.vue?vue&type=script&lang=js"
import style0 from "./tenantCompany.vue?vue&type=style&index=0&id=f8fd929c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fd929c",
  null
  
)

export default component.exports